
// const API_KEY = 'qpnf.u2794a2-/32';
// const API_URL = 'http://localhost:8000/api';
// export { API_URL, API_KEY};
const API_KEY = process.env.REACT_APP_API_KEY;
const API_URL = process.env.REACT_APP_API_URL;
export { API_URL, API_KEY};